<div class="db-booster-update">
  <h1 *ngIf="currentVersion">{{ companyName }} Booster V{{currentVersion}} Released!</h1>
  <h1 *ngIf="!currentVersion">New version of {{ companyName }}  Booster released!</h1>
  <p class="mt10"><span [innerHTML]="'text_updateBoosterPluginDesc' | dbText"></span></p>
  <div class="db-booster-update__buttons mt30">
    <a class="ds-btn-blue" *ngIf="websiteConnectedFrom === 'speed_optimizer'"
       target="_blank" rel="noopener"  [href]="adminPluginsUrl"
       (click)="confirm()">
      <span>Update the Plugin</span>
    </a>
  </div>
</div>
